import { render, staticRenderFns } from "./personManaging.vue?vue&type=template&id=0dd75fd8&"
import script from "./personManaging.vue?vue&type=script&lang=js&"
export * from "./personManaging.vue?vue&type=script&lang=js&"
import style0 from "./personManaging.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "personManaging.vue"
export default component.exports